import angular from 'angular';
import noteContent from './noteContent';
import './style.scss';

export default angular
  .module('components.noteContent', [])
  .component('noteContent', noteContent).name;
